var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(2.121 2.112)"},[React.createElement("line",{"x2":"5.334","y2":"5.439","transform":"translate(0 3.922)","fill":"none","stroke":"#0168b7","strokeLinecap":"round","strokeWidth":"3","key":0}),React.createElement("line",{"x1":"7.738","y2":"9.361","transform":"translate(5.334)","fill":"none","stroke":"#0168b7","strokeLinecap":"round","strokeWidth":"3","key":1})]));
}

Check.defaultProps = {"viewBox":"0 0 17.305 13.594"};

module.exports = Check;

Check.default = Check;
